"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttachmentByIdQuery = void 0;
const types_1 = require("../../types");
exports.getAttachmentByIdQuery = `
  query getAttachmentById($attachmentId: String!) {
    getAttachmentById(attachmentId: $attachmentId) {
      ...attachment
    }
  }
  ${types_1.attachmentFullFragment}
`;
//# sourceMappingURL=attatchment.js.map